import onsiteEmployeeApi from 'api/onsiteEmployee';
import { useEffect, useState } from 'react';
import { ListParams } from 'types';

export const useEmployeeListForOnsite = (params?: Partial<ListParams>) => {
  const [employeeList, setEmployeeList] = useState<Array<any>>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<unknown>(undefined);

  useEffect(() => {
    const fetchEmployeeListByLineCategoryAPI = async () => {
      try {
        setIsLoading(true);
        const response = await onsiteEmployeeApi.getEmployeeList(params);
        setEmployeeList(response?.data || []);
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEmployeeListByLineCategoryAPI();
  }, [params]);

  return { data: employeeList, isLoading: isLoading, error: error };
};
